import React from 'react';
import { useTranslation } from 'react-i18next';
import { PasswordRecovery } from '@components/templates/authentication';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';

export function PasswordRecoveryPage() {
    const { t } = useTranslation();

    const translations = {
        title: t('password-recovery-component.metatags.title'),
        description: t('password-recovery-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.recoverPassword,
        index: false,
    });

    return <PasswordRecovery />;
}
